const SelectConverter = ({ Converters, selectedConverter, setSelectedConverter }) => {
    return (
        <select
        id='converter-select'
        className='choice-select'
        value={selectedConverter}
        onChange={(e) => setSelectedConverter(e.target.value)}
        >
            {selectedConverter === '' ? <option value="">
                ------
            </option> : null}
            {Converters.map((converter) => (
                <option
                    key={converter.id}
                    value={converter.id}
                >
                    {converter.type} Tracks:{converter.track_amount} {converter.id}
                </option>
            ))}
        </select>
    );
};

export default SelectConverter;